<template>
  <a-row type="flex" justify="space-between">
    <a-col class="table-controls-margin">
      <a-form layout="inline" ref="formRef" :model="formState">
        <a-form-item>
          <a-input
            v-model:value="formState.search"
            placeholder="Buscar por ID o contacto"
            style="width: 200px"
          >
            <template #prefix>
              <search-outlined />
            </template>
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="formState.dateRange"
            style="width: 320px"
            format="DD/MM/YYYY HH:mm"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :show-time="{ format: 'HH:mm' }"
            :disabled-date="disabledDateRage"
            @calendarChange="handleCalendarChange"
          />
        </a-form-item>

        <entity-picker
          :value="formState.entity"
          @update:value="formState.entity = $event"
          :blockAllEntities="blockAllEntities"
          style="width: 160px"
          withOutEntities
        />

        <campaign-picker
          :value="formState.portfolio"
          @update:value="formState.portfolio = $event"
          :entity="formState.entity"
          style="width: 160px"
          :showAll="false"
        />
      </a-form>
    </a-col>

    <a-col class="table-controls-margin">
      <div class="refresh-wrapper">
        <a-button style="padding: 0" type="link" @click="handleUpdateData">
          Actualizar datos recientes
        </a-button>
      </div>

      <a-button @click="handleOpenAdvancedFiltersDrawer" style="margin-right: 8px">
        Filtros
        <filter-outlined />
      </a-button>

      <a-tooltip arrow-point-at-center placement="topRight">
        <template #title>
          <span v-if="isGlobalDownloading">Tiene una descarga pendiente</span>
          <span v-else>
            {{
              disabledDownload
                ? "No se puede realizar la descarga debido a la alta carga que conlleva la consulta."
                : "Tus emails se descargarán de acuerdo a los filtros seleccionados."
            }}
          </span>
        </template>

        <a-button
          @click="handleDownload"
          :loading="downloading"
          :disabled="disabledDownload || isGlobalDownloading"
        >
          Descargar
          <download-outlined />
        </a-button>
      </a-tooltip>
    </a-col>
  </a-row>

  <!-- <div v-if="selectedRows.length !== 0" class="multiselect-row">
    <div class="counter">
      <span>
        <template v-if="selectedRows.length === 1">
          Se ha seleccionado <strong>1 email</strong> de esta página.
        </template>
        <template v-else>
          Se han seleccionado <strong>{{ selectedRows.length }} emails</strong> de esta página.
        </template>
      </span>
    </div>

    <div class="actions">
      <a-tooltip
        placement="bottom"
        :title="
          uniquePortfolios.length !== 1
            ? 'Los emails seleccionados deben pertenecer a una sola campaña para poder ser transferidos. '
            : null
        "
      >
        <a-dropdown placement="bottomRight" :trigger="['click']" @click="handleTransferClick">
          <a-button :disabled="uniquePortfolios.length !== 1" type="link" @click.prevent>
            Transferir <SwapOutlined />
          </a-button>

          <template #overlay>
            <a-menu @click="handleDropdownClick">
              <a-menu-item
                key="users"
                :disabled="uniqueQueues.length !== 1 || uniqueQueues.includes(null)"
              >
                <a-tooltip
                  :title="
                    uniqueQueues.length !== 1
                      ? 'Los emails seleccionados deben pertenecer a una misma cola para poder ser transferidos a un usuario.'
                      : null
                  "
                  placement="left"
                >
                  Transferir a un usuario
                </a-tooltip>
              </a-menu-item>

              <a-menu-item key="queues"> Transferir a cola </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </a-tooltip>

      <a-divider type="vertical" class="divider" />

      <a-dropdown placement="bottomRight">
        <a-button type="link" @click.prevent> Etiquetar <TagOutlined /> </a-button>

        <template #overlay>
          <a-menu v-if="tagsData.length !== 0" @click="handleTagDropdownClick">
            <a-menu-item v-for="tag in tagsData" :key="tag.id">
              <div class="tag-dropdown-menu">
                <div class="tag-color" :style="{ backgroundColor: `#${tag.color}` }" />
                <span>
                  {{ tag.name }}
                </span>
              </div>
            </a-menu-item>
          </a-menu>

          <a-menu v-else>
            <a-menu-item disabled> No hay etiquetas </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>

      <a-divider type="vertical" class="divider" />

      <a-button type="link" @click="handleResolve"> Resolver <CheckOutlined /> </a-button>
    </div>

  </div> -->

  <section v-if="wrongInputsMessage.show">{{ wrongInputsMessage.content }}</section>
</template>

<script>
import { computed, onMounted, ref, inject, reactive, watch, createVNode } from "vue";
import { useStore } from "vuex";
import { Modal, message } from "ant-design-vue";
import _ from "lodash";
import {
  QuestionCircleOutlined,
  SearchOutlined,
  FilterOutlined,
  DownloadOutlined,
  // TagOutlined,
  // CheckOutlined,
  // SwapOutlined,
} from "@ant-design/icons-vue";

import { disabledDateFuture, dateToString } from "@/app/shared/utils/dates";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import { useDateRangeLimit } from "@/app/shared/composables/useDateRangeLimit";

import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
// import QueueTransferModal from "@/app/emailsManager/components/modals/transfer/QueueTransferModal.vue";
// import UserTransferModal from "@/app/emailsManager/components/modals/transfer/UserTransferModal.vue";

export default {
  components: {
    EntityPicker,
    CampaignPicker,
    SearchOutlined,
    FilterOutlined,
    DownloadOutlined,
    // TagOutlined,
    // CheckOutlined,
    // SwapOutlined,
    // QueueTransferModal,
    // UserTransferModal,
  },
  props: {
    selectedRows: {
      type: Array,
      required: true,
    },
    downloading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { isGlobalDownloading } = useGlobalDownloadState();

    const { handleCalendarChange, disabledDateRage } = useDateRangeLimit();

    const currentDay = dateToString(new Date()).substring(0, 10);
    const wrongInputsMessage = reactive({ show: false, content: "" });

    const formRef = ref(null);
    const formState = reactive({
      entity: "",
      portfolio: null,
      // channel: "",
      search: "",
      dateRange: [`${currentDay} 00:00:00`, `${currentDay} 23:59:59`],
    });

    const blockAllEntities = ref(false);
    // const disabledDownload = computed(() => formState.entity === "" && formState.channel === "");

    // Get tags and emailManagerChannels data
    onMounted(() => {
      store.dispatch("fetchTags");

      const { entity, portfolio, search, dateRange } = formState;

      const fields = {
        entity: entity ?? "",
        portfolio,
        search,
        startDate: dateToString(dateRange[0]),
        endDate: dateToString(dateRange[1]),
      };

      emit("form-fields-completed", fields);
    });

    watch(
      formState,
      _.debounce(() => {
        const { entity, portfolio, search, dateRange } = formState;

        if (!(entity > 0 && !portfolio)) {
          const fields = {
            entity: entity ?? "",
            portfolio,
            search,
            startDate: dateToString(dateRange[0]),
            endDate: dateToString(dateRange[1]),
          };

          emit("form-fields-completed", fields);
        }

        if (formState.entity === "" || formState.entity === 0) {
          wrongInputsMessage.show = false;
          emit("show-table", true);
        }

        if (formState.entity && !formState.portfolio) {
          wrongInputsMessage.show = true;
          wrongInputsMessage.content = "Debe seleccionar una campaña para poder mostrar los emails";
          blockAllEntities.value = false;
          emit("show-table", false);
        }

        if (entity !== "" && portfolio) {
          wrongInputsMessage.show = false;
          emit("show-table", true);
        }
      }, 600),
      { deep: false }
    );

    const selectedTableRowKeys = inject("selectedTableRowKeys");
    const updateSelectedTableRowKeys = inject("updateSelectedTableRowKeys");
    const selectedRowsList = inject("selectedRowsList");

    const openQueueTransferModal = ref(false);
    const openUserTransferModal = ref(false);

    const transferEmailsData = computed(() => store.getters["getTransferEmailsData"]);
    const uniquePortfolios = computed(() => [
      ...new Set(selectedRowsList.value.map((item) => item.portfolio)),
    ]);
    const uniqueQueues = computed(() => [
      ...new Set(selectedRowsList.value.map((item) => item.queue)),
    ]);

    // watch(uniquePortfolios, (newUniquePortfolios, oldUniquePortfolios) => {
    //   if (newUniquePortfolios.length !== 1) return;
    //   if (isEqual(newUniquePortfolios, oldUniquePortfolios)) return;

    //   store.dispatch("fetchTransferEmailsData", selectedRowsList.value.at(0)?.id);
    // });
    const handleTransferClick = async () => {
      const emailId = selectedRowsList.value.at(0)?.id;

      await store.dispatch("fetchTransferEmailsData", emailId);
    };

    const handleDropdownClick = async ({ key } = {}) => {
      if (key === "users") openUserTransferModal.value = true;
      if (key === "queues") openQueueTransferModal.value = true;
    };

    const tagsData = computed(() => store.getters["getTags"]);

    const handleTagDropdownClick = ({ key: tagId }) => {
      // Mejora de performance: Enviar los datos de la tag en el payload, luego ejecutar el commit antes de la petición.

      const payload = {
        emailsId: [...selectedTableRowKeys.value],
        tagId,
      };

      store.dispatch("tagEmails", payload);
      message.success("Se han etiquetado los emails correctamente");
    };

    const handleResolve = () => {
      Modal.confirm({
        title: `¿Estás seguro de resolver ${modalTitleEmails}?`,
        content: `Estás por resolver ${modalChannelNumbers}. Recuerda que ${
          emailsNumber === 1 ? "desaparecerá" : "desaparecerán"
        } del workspace del usuario y ${
          emailsNumber === 1
            ? "si no cuenta con tipificación se le"
            : "aquellas que no cuenten con tipificación se les"
        } asignará una por defecto. Además, si existen llamadas activas serán finalizadas.`,
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        onOk: () => {
          store.dispatch("resolveEmails", [...selectedTableRowKeys.value]);
          message.success("Se han resuelto los emails correctamente");
          updateSelectedTableRowKeys([]);
          handleUpdateData();
        },
        okText: "Resolver",
        cancelText: "Cancelar",
      });
    };

    const handleUpdateData = () => {
      emit("update-data");
    };

    const handleOpenAdvancedFiltersDrawer = () => {
      emit("open-advanced-filters-drawer");
    };

    const handleDownload = () => {
      emit("file-download");
    };

    return {
      blockAllEntities,
      // disabledDownload,
      handleCalendarChange,
      disabledDateRage,
      wrongInputsMessage,
      isGlobalDownloading,
      formRef,
      formState,
      tagsData,
      handleTagDropdownClick,
      handleResolve,
      handleUpdateData,
      handleOpenAdvancedFiltersDrawer,
      handleDownload,
      disabledDateFuture,
      selectedRowsList,
      openQueueTransferModal,
      openUserTransferModal,
      uniquePortfolios,
      uniqueQueues,
      transferEmailsData,
      handleTransferClick,
      handleDropdownClick,
      updateSelectedTableRowKeys,
    };
  },
};
</script>

<style lang="sass" scoped>
.table-controls-margin
  margin-bottom: 5px

.selected-rows-buttons__wrapper
  display: flex
  flex-direction: column
  align-items: flex-end
  position: relative

.refresh-wrapper, .selected-rows-counter
  position: absolute
  bottom: 32px
  margin-bottom: 4px
  font-size: 16px

.refresh-wrapper
  right: 0
  bottom: 28px

.tag-dropdown-menu
  display: flex
  align-items: center

.tag-color
  width: 8px
  height: 8px
  border-radius: 50%
  margin-right: 8px

section
  display: grid
  justify-items: center
  color: $gray-6
  font-size: 20px
  margin: auto 0

.multiselect-row
  text-align: center

  .counter
    color: $gray-8
    background-color: $geekblue-4
    padding: 4px 0

  .actions
    background-color: $geekblue-1
    padding: 3px 0

  .divider
    background-color: $text-secondary
    height: 1.5em
</style>

<style>
.table-controls-margin .ant-form-item {
  margin-right: 8px !important;
}
</style>
